const exceptionNickname = [
  "a",
  "i",
  "ir",
  "dr",
  "m",
  "moch",
  "much",
  "muh",
  "moh",
  "ni",
  "rr",
  "hj",
  "mohamad",
  "mohammad",
  "muhamad",
  "muhammad",
  "mochamad",
  "mochammad",
  "muchamad",
  "muchammad",
];

export { exceptionNickname };
